(function () {
  'use strict';

  var CATALOG_CACHE = null;
  var CATALOG_PROMISE = null;

  var STOPWORDS = new Set([
    'a','an','the','for','and','or','of','to','in','on','with','my','me','i',
    'is','are','be','some','something','that','this','look','fit','outfit',
    'need','want','under','egp','le','pounds','pound'
  ]);

  // Vibe / occasion keyword dictionary. Each category lists the query
  // keywords that trigger it, and the tag/type/title substrings used to
  // score matching catalog products.
  var CATEGORIES = [
    {
      key: 'gym',
      queryWords: ['gym', 'workout', 'work out', 'training', 'leg day', 'lift', 'lifting', 'cardio', 'run', 'running', 'sport', 'sports', 'active', 'squat'],
      matchTerms: ['gym', 'training', 'sport', 'active', 'workout', 'compression', 'muscle', 'tank top', 'sports bra', 'leggings', 'short', 'gym wear', 'dri fit', 'dry fit'],
      adjective: 'high-energy',
      occasion: 'leg day at the gym'
    },
    {
      key: 'street',
      queryWords: ['street', 'streetwear', 'oversized', 'weekend', 'hangout', 'chill', 'baggy'],
      matchTerms: ['streetwear', 'oversized', 'casual', 'sweatshirt', 'hoodie', 'joggers', 'sweatpants', 'box fit', 'brushed'],
      adjective: 'relaxed streetwear',
      occasion: 'a laid-back weekend out'
    },
    {
      key: 'travel',
      queryWords: ['travel', 'travelling', 'traveling', 'cosy', 'cozy', 'layers', 'comfy', 'flight', 'airport', 'lounge', 'loungewear'],
      matchTerms: ['loungewear', 'lounge', 'cozy', 'cosy', 'comfy', 'sweatpants', 'jacket', 'hoodie', 'set', 'cloud'],
      adjective: 'cozy travel-ready',
      occasion: 'travelling in comfort'
    },
    {
      key: 'smart',
      queryWords: ['dinner', 'smart-casual', 'smart casual', 'night out', 'date', 'rooftop', 'dressy', 'occasion'],
      matchTerms: ['smart casual', 'casual look', 'polo shirt', 'shirt', 'henley'],
      adjective: 'smart-casual',
      occasion: 'a night out'
    },
    {
      key: 'hijab',
      queryWords: ['hijab', 'modest', 'hijabi'],
      matchTerms: ['hijab', 'modest', 'hijabi', 'terra', 'modestactivewear'],
      adjective: 'modest, sport-ready',
      occasion: 'training in comfort and coverage'
    },
    {
      key: 'kids',
      queryWords: ['kid', 'kids', 'child', 'children', 'son', 'daughter', 'girl', 'boy'],
      matchTerms: ['kids', 'kid', 'boys', 'girls', 'children'],
      adjective: 'playful kids',
      occasion: 'the little athlete in your life'
    },
    {
      key: 'football',
      queryWords: ['football', 'soccer', 'match', 'game day', 'jersey'],
      matchTerms: ['jersey', 'football', 'soccer', 'training bibs'],
      adjective: 'game-day',
      occasion: 'match day'
    }
  ];

  // Explicit garment nouns. When the shopper names one of these, it becomes
  // a HARD filter (not a score boost). Order matters: more specific groups
  // come first, and matched text is consumed so generic groups (shirt/top)
  // don't double-fire on e.g. "t-shirt" or "tank top".
  var GARMENTS = [
    { key: 'sweatshirt', label: 'sweatshirt', q: /\bsweat[- ]?shirts?\b/, m: /sweatshirt|sweat shirt/ },
    { key: 'pants', label: 'pants', q: /\bsweat[- ]?pants\b|\bjoggers?\b|\bpants\b|\btrousers?\b|\bpajamas?\b/, m: /\bpants\b|\bjoggers?\b|\bsweatpants\b|\btrousers\b|\bpajama\b/ },
    { key: 'tank', label: 'tank top', q: /\btank[- ]?tops?\b|\btanks?\b|\bvests?\b/, m: /\btank\b|\bvest\b/ },
    { key: 'bra', label: 'sports bra', q: /\bsports?[- ]?bras?\b|\bbras?\b/, m: /\bbras?\b/ },
    { key: 'swim', label: 'swimwear', q: /\bswim[- ]?(?:shorts?|suits?|wear|ming)?\b|\bburkini\b/, m: /swim|burkini/ },
    { key: 'tshirt', label: 't-shirt', q: /\bt[- ]?shirts?\b|\btees?\b/, m: /t-shirt|t shirt|\btshirts?\b|\btees?\b/ },
    { key: 'polo', label: 'polo', q: /\bpolos?\b/, m: /polo/ },
    { key: 'jersey', label: 'jersey', q: /\bjerseys?\b/, m: /jersey/ },
    { key: 'hoodie', label: 'hoodie', q: /\bhood(?:ies?|ed)?\b/, m: /hood/ },
    { key: 'jacket', label: 'jacket', q: /\bjackets?\b|\bzip[- ]?ups?\b/, m: /jacket|zip/ },
    { key: 'shirt', label: 'top', q: /\bshirts?\b|\btops?\b/, m: /shirt|\btops?\b|\btees?\b|t-shirt/ },
    { key: 'shorts', label: 'shorts', q: /\bshorts?\b/, m: /\bshorts\b|\bshort\b(?!(?:\s|-)?sleeve)/ },
    { key: 'leggings', label: 'leggings', q: /\bleggings?\b|\btights?\b/, m: /legging/ },
    { key: 'skirt', label: 'skirt', q: /\bskirts?\b/, m: /skirt/ },
    // "hijab sportswear" describes a modest-wear vibe, not the scarf itself,
    // so only treat hijab as a garment when it isn't qualifying another word.
    { key: 'hijab', label: 'hijab', q: /\bhijabs?\b(?!\s*(?:sports?|sportswear|activewear|wear|outfit|look|style|fit))|\bhead ?bands?\b|\bscar(?:f|ves)\b|\bhead ?covers?\b/, m: /hijab|headband|head band|scarf|head cover/ },
    { key: 'socks', label: 'socks', q: /\bsocks?\b/, m: /\bsocks?\b/ },
    { key: 'set', label: 'set', q: /\bsets?\b/, m: /\bsets?\b/ },
    { key: 'dress', label: 'dress', q: /\bdress(?:es)?\b|\btunics?\b/, m: /dress|tunic/ }
  ];

  // Style adjectives strongly boost — but never exclude — matching items.
  var ADJECTIVES = ['oversized', 'slim', 'compression', 'modest', 'printed', 'baggy', 'fitted', 'ribbed', 'seamless', 'stretch', 'breathable', 'lightweight', 'dri fit', 'dry fit', 'high waist', 'box fit'];

  var MAX_RESULTS = 5;

  // Shared CDN prefix — catalog color image refs are stored as suffixes.
  var CDN_PREFIX = 'https://cdn.shopify.com/s/files/1/0072/1036/9069/files/';

  // Color vocabulary matching the real values in the catalog. Multi-word
  // phrases first so "sky blue" is consumed before "blue" / "sky".
  var COLOR_PHRASES = ['sky blue', 'teal blue', 'teal green', 'lime green', 'mint green', 'navy blue', 'royal blue', 'off white', 'hunter green', 'ocean blue', 'dark grey', 'light grey', 'heather grey', 'barbie pink', 'mustard yellow', 'denim blue', 'kiwi green'];
  var COLOR_WORDS = ['black', 'white', 'grey', 'gray', 'red', 'navy', 'blue', 'lime', 'mint', 'olive', 'green', 'yellow', 'orange', 'pink', 'purple', 'lavender', 'brown', 'beige', 'burgundy', 'maroon', 'teal', 'simon', 'peach', 'charcoal', 'rose', 'fuchsia', 'khaki', 'turquoise', 'sky', 'mustard', 'sand', 'plum', 'blush', 'nude', 'coffee'];

  // ---- Bilingual (Arabic → English) query translation ----
  // Arabic/Egyptian-Arabic phrases are translated to the English tokens the
  // engine already understands, so every downstream detector (audience,
  // garment, color, vibe, budget) works unchanged. Longest phrases first.
  var AR_MAP = [
    // budget
    [/أقل من|اقل من|تحت|بحد أقصى|بحد اقصى/g, ' under '],
    [/جنيه(?:ات)?|چنيه|ج\.م/g, ' egp '],
    // audience
    [/حريمي|نسائي|نسائى|للنساء|نساء|ستاتي|ستاتى|بناتي|بناتى|للبنات|مدام/g, ' ladies '],
    [/رجالي|رجالى|للرجال|رجاله|رجال|شبابي|شبابى|ولادي|ولادى/g, ' men '],
    [/أطفال|اطفال|كيدز|للأطفال|للاطفال|عيال|طفله|طفلة|طفل/g, ' kids '],
    // garments
    [/تي شيرتات|تى شيرتات|تيشيرتات|تيشرتات|تي شيرت|تى شيرت|تيشيرت|تيشرت/g, ' t-shirt '],
    [/شورتات|شورت/g, ' shorts '],
    [/ليجنز|ليجينز|ليقنز|لقنز|ليجن|ليقن/g, ' leggings '],
    [/بنطلونات|بناطيل|بنطلون/g, ' pants '],
    [/هوديز|هودي/g, ' hoodie '],
    [/جاكيتات|جاكيت|جاكت/g, ' jacket '],
    [/سويت شيرت|سويتشيرت/g, ' sweatshirt '],
    [/طرح(?:ه|ة)|طرح|إيشارب|ايشارب|باندانا|حجاب/g, ' hijab '],
    [/شرابات|جوارب|شراب/g, ' socks '],
    [/مايوهات|مايوه/g, ' swim shorts '],
    [/جيرسي|جرسي/g, ' jersey '],
    [/تنور(?:ه|ة)|جيب(?:ه|ة)/g, ' skirt '],
    [/ستيان رياضي|سبورت برا|برا رياضي/g, ' sports bra '],
    [/أطقم|اطقم|طقم|(?:^|[^ء-ي])سيت(?![ء-ي])/g, ' set '],
    [/بولو/g, ' polo '],
    [/تانك توب|فانلات|فانله|فانلة/g, ' tank top '],
    [/(?:^|[^ء-ي])توب(?![ء-ي])/g, ' top '],
    // colors
    [/أسود|اسود/g, ' black '], [/أبيض|ابيض/g, ' white '],
    [/أحمر|احمر/g, ' red '], [/أزرق|ازرق/g, ' blue '],
    [/أخضر|اخضر/g, ' green '], [/أصفر|اصفر/g, ' yellow '],
    [/رمادي|رمادى|جراي|رصاصي|رصاصى/g, ' grey '], [/كحلي|كحلى/g, ' navy '],
    [/بني|بنى\b/g, ' brown '], [/بيج/g, ' beige '],
    [/وردي|وردى|بمبي|بمبى|بينك/g, ' pink '], [/موف|لافندر/g, ' lavender '],
    [/بنفسجي|بنفسجى/g, ' purple '], [/برتقالي|برتقالى|اورنج|أورنج/g, ' orange '],
    [/نبيتي|نبيتى|عنابي|عنابى/g, ' burgundy '], [/زيتوني|زيتونى|زيتي|زيتى/g, ' olive '],
    [/تركواز/g, ' teal '], [/لبني|لبنى|سماوي|سماوى/g, ' sky blue '],
    [/فوشيا/g, ' fuchsia '], [/اوف وايت|أوف وايت/g, ' off white '],
    // vibes / occasions
    [/تمرين(?:ه|ة)?|تدريب|رياضي(?:ه|ة)?|رياضى|رياض(?:ه|ة)|جيم/g, ' gym '],
    [/كاجوال/g, ' casual weekend '],
    [/خروج(?:ه|ة)?|سهر(?:ه|ة)|عشاء|عشا\b/g, ' night out '],
    [/سفر|مسافر(?:ه|ة)?/g, ' travel '],
    [/محجبات|محجب(?:ه|ة)|محتشم(?:ه|ة)?/g, ' hijab modest '],
    [/اوفرسايز|أوفرسايز|فضفاض(?:ه|ة)?|واسع(?:ه|ة)?/g, ' oversized '],
    [/كور(?:ه|ة)|ماتش|فوتبول/g, ' football '],
    [/بحر|مصيف|ساحل/g, ' swim '],
    [/دافي|شتوي|شتوى|مريح(?:ه|ة)?/g, ' cozy ']
  ];

  var ARABIC_DIGITS = { '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4', '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9' };

  function hasArabic(s) {
    return /[؀-ۿ]/.test(s);
  }

  // Normalize (Arabic-Indic digits, alef/yaa variants, diacritics) and
  // translate known Arabic phrases into English engine tokens.
  function normalizeAndTranslate(raw) {
    var s = raw.toLowerCase();
    s = s.replace(/[٠-٩]/g, function (d) { return ARABIC_DIGITS[d] || d; });
    s = s.replace(/[ً-ٰٟـ]/g, ''); // diacritics + tatweel
    s = s.replace(/[أإآ]/g, 'ا').replace(/ى/g, 'ي');
    AR_MAP.forEach(function (pair) {
      s = s.replace(pair[0], pair[1]);
    });
    return s.replace(/\s+/g, ' ').trim();
  }

  // ---- Negation handling ("non hijabi", "not modest", "بدون حجاب") ----
  // Extracts negated terms as hard EXCLUSIONS and strips the negation
  // phrase so it can never positively match. Returns
  // {stripped, excludeTerms: [regex...], excludeColors: [...]}.
  var NEGATION_RE = /(?:\bnon\b|\bnot\b|\bno\b|\bwithout\b|بدون|بلا|غير|مش)[\s-]*([a-z؀-ۿ][a-z؀-ۿ-]*(?:\s+(?:hijab|hijabi|modest))?)/g;

  var EXCLUDE_SYNONYMS = {
    hijab: /hijab|modest|tunic/, hijabi: /hijab|modest|tunic/,
    hijabs: /hijab|modest|tunic/, modest: /hijab|modest|tunic/,
    'hijab modest': /hijab|modest|tunic/
  };

  function extractNegations(queryLower) {
    var excludeTerms = [];
    var excludeColors = [];
    var stripped = queryLower.replace(NEGATION_RE, function (full, term) {
      term = term.trim();
      if (EXCLUDE_SYNONYMS[term]) {
        excludeTerms.push(EXCLUDE_SYNONYMS[term]);
      } else if (COLOR_PHRASES.indexOf(term) !== -1 || COLOR_WORDS.indexOf(term) !== -1) {
        excludeColors.push(term);
      } else if (term.length >= 3) {
        excludeTerms.push(new RegExp(term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')));
      }
      return ' ';
    });
    return { stripped: stripped.replace(/\s+/g, ' ').trim(), excludeTerms: excludeTerms, excludeColors: excludeColors };
  }

  function isExcluded(p, excludeTerms, excludeColors) {
    var hay = haystackFor(p);
    for (var i = 0; i < excludeTerms.length; i++) {
      if (excludeTerms[i].test(hay)) return true;
    }
    for (var j = 0; j < excludeColors.length; j++) {
      var c = excludeColors[j];
      if ((p.colors && Object.prototype.hasOwnProperty.call(p.colors, c)) || hay.indexOf(c) !== -1) return true;
    }
    return false;
  }

  // Detect colors named in the query. Returns {colors: [...], stripped: query
  // with the color words removed} so color terms never double-count as
  // garment or vibe words.
  function detectColors(queryLower) {
    var working = ' ' + queryLower + ' ';
    var colors = [];
    COLOR_PHRASES.concat(COLOR_WORDS).forEach(function (c) {
      var re = new RegExp('\\b' + c.replace(/ /g, '\\s+') + '\\b', 'g');
      if (re.test(working)) {
        colors.push(c);
        working = working.replace(re, ' ');
      }
    });
    return { colors: colors, stripped: working.replace(/\s+/g, ' ').trim() };
  }

  // A queried color matches a product when the product's colors map has the
  // full name or its base-word index (the catalog indexes both).
  function matchedColorKey(p, colors) {
    if (!p.colors) return null;
    for (var i = 0; i < colors.length; i++) {
      if (Object.prototype.hasOwnProperty.call(p.colors, colors[i])) return colors[i];
    }
    return null;
  }

  function colorAllows(p, colors) {
    if (!colors || colors.length === 0) return true;
    return matchedColorKey(p, colors) !== null;
  }

  // Resolve a product's card image for the queried colors: '' means the
  // featured image already shows this color; a bare suffix is CDN-relative.
  function colorImageFor(p, colors) {
    var key = colors && colors.length ? matchedColorKey(p, colors) : null;
    if (!key) return p.image;
    var ref = p.colors[key];
    if (!ref) return p.image;
    if (ref.indexOf('http') === 0) return ref;
    return CDN_PREFIX + ref;
  }

  function parseBudget(query) {
    var m = query.match(/under\s*(\d[\d,]*)/i) || query.match(/(\d[\d,]*)\s*egp/i) || query.match(/budget\s*(?:of|is|:)?\s*(\d[\d,]*)/i);
    if (m) {
      var n = parseInt(m[1].replace(/,/g, ''), 10);
      if (!isNaN(n) && n > 0) return n;
    }
    return null;
  }

  function tokenize(query) {
    return query
      .toLowerCase()
      .replace(/[^\p{L}\p{N}\s-]/gu, ' ')
      .split(/\s+/)
      .filter(function (w) { return w.length >= 3 && !STOPWORDS.has(w); });
  }

  function matchedCategories(queryLower) {
    var hits = [];
    CATEGORIES.forEach(function (cat) {
      for (var i = 0; i < cat.queryWords.length; i++) {
        if (queryLower.indexOf(cat.queryWords[i]) !== -1) {
          hits.push(cat);
          break;
        }
      }
    });
    return hits;
  }

  function haystackFor(product) {
    if (!product._hay) {
      product._hay = (product.title + ' ' + product.type + ' ' + product.tags.join(' ')).toLowerCase();
    }
    return product._hay;
  }

  // ---- Hard filters: audience (gender/kids) & garment type ----

  // Audience stated in the query. Kids first (most specific), then women
  // before men so \bmen\b never wins on "women"-family words.
  function detectAudience(queryLower) {
    if (/\b(kids?|child|children|toddler|junior|son|daughter|boys?)\b/.test(queryLower)) return 'kids';
    if (/\b(ladies|lady|women|woman|womens|female|hijabi|girls?|her)\b/.test(queryLower)) return 'women';
    if (/\b(men|man|mens|male|guys?|him|gents?)\b/.test(queryLower)) return 'men';
    return null;
  }

  // Audience of a catalog product. Kids markers in title/tags take priority
  // (kids items are often filed under "Men ..." product types); then the
  // productType prefix is the primary signal, tags the fallback
  // (DOE = women's line, Viga = men's line). Returns null for unisex /
  // accessory items with no clear signal.
  function audienceOf(p) {
    if (p._aud !== undefined) return p._aud;
    var hay = haystackFor(p);
    var aud = null;
    // NOTE: no boys/girls here — adult items carry tags like "girls skirt";
    // real kids products always say kid/kids/child/junior.
    if (/\bkids?\b|\bchild(?:ren)?\b|\bjunior\b/.test(hay)) {
      aud = 'kids';
    } else {
      var t = (p.type || '').toLowerCase();
      if (t.indexOf('women') === 0) aud = 'women';
      else if (t.indexOf('men') === 0) aud = 'men';
      else if (t.indexOf('cover-up') === 0 || t === 'skirts') aud = 'women';
      else {
        var w = /\bladies\b|\blady\b|\bwomen\b|\bwoman\b|\bdoe\b|\bhijab\b|\bfemale\b/.test(hay);
        var m = /\bmen\b|\bman\b|\bmenswear\b|\bviga\b|\bmale\b/.test(hay);
        if (w && !m) aud = 'women';
        else if (m && !w) aud = 'men';
      }
    }
    p._aud = aud;
    return aud;
  }

  function audienceAllows(p, requested) {
    var aud = audienceOf(p);
    // kids products only surface when kids are explicitly asked for
    if (!requested) return aud !== 'kids';
    if (requested === 'kids') return aud === 'kids';
    // wrong-gender items are EXCLUDED; unisex/accessories (null) pass
    return aud === requested || aud === null;
  }

  // Detect garment nouns; consume matched text so overlapping generic
  // groups don't double-fire. Returned in the order they appear in the query.
  function detectGarments(queryLower) {
    var working = ' ' + queryLower + ' ';
    var found = [];
    GARMENTS.forEach(function (g) {
      var re = new RegExp(g.q.source, 'g');
      if (re.test(working)) {
        var pos = queryLower.search(new RegExp(g.q.source));
        found.push({ garment: g, pos: pos < 0 ? 9999 : pos });
        working = working.replace(new RegExp(g.q.source, 'g'), ' ');
      }
    });
    found.sort(function (a, b) { return a.pos - b.pos; });
    return found.map(function (f) { return f.garment; });
  }

  function matchesGarment(p, g) {
    return g.m.test(haystackFor(p));
  }

  function scoreProduct(product, terms, words, adjectives) {
    var hay = haystackFor(product);
    var score = 0;
    terms.forEach(function (t) {
      if (hay.indexOf(t) !== -1) score += 2;
    });
    words.forEach(function (w) {
      if (hay.indexOf(w) !== -1) score += 1;
    });
    (adjectives || []).forEach(function (a) {
      if (hay.indexOf(a) !== -1) score += 4;
    });
    score += (product.rating || 0) / 10;
    return score;
  }

  function pickOutfit(scored, maxBudget) {
    // scored: array of {product, score} sorted desc by score
    var chosen = [];
    var usedTypes = {};
    var total = 0;

    function fits(p) {
      return maxBudget == null || total + p.price <= maxBudget;
    }

    // pass 1: top scoring item of distinct types, up to MAX_RESULTS
    for (var i = 0; i < scored.length && chosen.length < MAX_RESULTS; i++) {
      var p = scored[i].product;
      if (scored[i].score <= 0) break;
      var t = p.type || p.title;
      if (usedTypes[t]) continue;
      if (!fits(p)) continue;
      chosen.push(p);
      usedTypes[t] = true;
      total += p.price;
    }

    // pass 2: fill remaining slots ignoring type-variety constraint
    if (chosen.length < MAX_RESULTS) {
      for (var j = 0; j < scored.length && chosen.length < MAX_RESULTS; j++) {
        var p2 = scored[j].product;
        if (scored[j].score <= 0) break;
        if (chosen.indexOf(p2) !== -1) continue;
        if (!fits(p2)) continue;
        chosen.push(p2);
        total += p2.price;
      }
    }

    return chosen;
  }

  // Garment-constrained selection.
  // Single garment: up to MAX_RESULTS products OF THAT TYPE (each within
  // budget) — fewer is fine, never padded with unrelated items.
  // Multiple garments: one slot per named garment (query order), remaining
  // slots filled from the union of the garment pools.
  function pickByGarments(scoredBase, garments, maxBudget) {
    var pools = garments.map(function (g) {
      return scoredBase
        .filter(function (s) { return matchesGarment(s.product, g); })
        .map(function (s) {
          // items whose TITLE names the garment beat tag-only matches
          var titleHit = g.m.test((s.product.title || '').toLowerCase());
          return { product: s.product, score: s.score + (titleHit ? 5 : 0) };
        })
        .sort(function (a, b) { return b.score - a.score; });
    });

    var chosen = [];
    function take(pool) {
      for (var i = 0; i < pool.length; i++) {
        var p = pool[i].product;
        if (chosen.indexOf(p) !== -1) continue;
        chosen.push(p);
        return true;
      }
      return false;
    }

    if (garments.length === 1) {
      if (pools[0].length === 0) return null; // caller relaxes the garment filter
      // strictly items OF the named type — fewer than MAX_RESULTS is fine,
      // never pad with unrelated items.
      while (chosen.length < MAX_RESULTS && take(pools[0])) {}
      return chosen;
    }

    // multiple garments: primary slot must be the first named garment
    if (pools[0].length === 0) return null;
    pools.forEach(function (pool) {
      if (chosen.length < MAX_RESULTS) take(pool);
    });
    var union = [];
    pools.forEach(function (pool) { union = union.concat(pool); });
    union.sort(function (a, b) { return b.score - a.score; });
    while (chosen.length < MAX_RESULTS && take(union)) {}

    // budget applies to the combined outfit for multi-garment looks
    if (maxBudget != null) {
      var total = 0;
      chosen = chosen.filter(function (p) {
        if (total + p.price <= maxBudget) { total += p.price; return true; }
        return false;
      });
    }
    return chosen.length ? chosen : null;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatEGP(n) {
    return Math.round(n).toLocaleString('en-US') + ' EGP';
  }

  function productCardHTML(p, queryColors) {
    var onSale = p.tags.indexOf('on-sale') !== -1 || p.tags.indexOf('black friday') !== -1 || p.tags.indexOf('clearance') !== -1;
    var priceHtml;
    if (onSale) {
      // No compare-at price in dataset; approximate a modest strike-through
      // presentation using the sale tag as a visual cue only when it reads
      // naturally — otherwise just show the price.
      priceHtml = '<span class="ai-stylist-price ai-stylist-price--sale">' + formatEGP(p.price) + '</span>' +
        '<span class="ai-stylist-sale-badge">Sale</span>';
    } else {
      priceHtml = '<span class="ai-stylist-price">' + formatEGP(p.price) + '</span>';
    }
    var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'products/' + p.handle
      : '/products/' + p.handle;

    // Show the queried color's variant image when a color filter applied.
    // Request a right-sized CDN variant so lazy-loaded cards appear fast
    // instead of pulling multi-megapixel originals.
    var imgSrc = colorImageFor(p, queryColors);
    if (imgSrc && imgSrc.indexOf('cdn.shopify.com') !== -1 && imgSrc.indexOf('width=') === -1) {
      imgSrc += (imgSrc.indexOf('?') !== -1 ? '&' : '?') + 'width=600';
    }

    return (
      '<a class="ai-stylist-card" href="' + escapeHtml(url) + '">' +
        '<span class="ai-stylist-card__media">' +
          '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="400" height="500">' +
          '<button type="button" class="ai-stylist-card__heart" aria-label="Save to wishlist" data-ai-heart>' +
            '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 20.5s-7.5-4.6-10-9.3C.5 8 2 4.5 5.5 4c2-.3 3.7.7 4.9 2.3C11.6 4.7 13.3 3.7 15.3 4c3.5.5 5 4 3.5 7.2-2.5 4.7-10 9.3-10 9.3z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>' +
          '</button>' +
        '</span>' +
        '<span class="ai-stylist-card__title">' + escapeHtml(p.title) + '</span>' +
        '<span class="ai-stylist-card__price-row">' + priceHtml + '</span>' +
      '</a>'
    );
  }

  function joinNames(chosen) {
    var names = chosen.map(function (p) { return p.title; });
    if (names.length === 0) return '';
    if (names.length === 1) return names[0];
    if (names.length === 2) return names[0] + ' with ' + names[1];
    return names[0] + ' with ' + names.slice(1, -1).join(', ') + ' and ' + names[names.length - 1];
  }

  function buildDescription(query, chosenCategories, chosen, garmentMode, colors, arabicMode) {
    var colorPhrase = colors && colors.length ? colors.join(' / ') : '';
    var names = chosen.map(function (p) { return p.title; });
    if (arabicMode) {
      var listAr = names.length <= 1 ? (names[0] || '') : names.slice(0, -1).join('، ') + ' و ' + names[names.length - 1];
      if (garmentMode) {
        return '✦ اخترنالك على طلبك' + (colorPhrase ? ' — باللون المطلوب' : '') + ': ' + listAr + '.';
      }
      return '✦ لوك متكامل مخصوص ليك: ' + listAr + ' — هيظبطك 🔥';
    }
    if (garmentMode) {
      // item-focused query: present picks rather than a mixed "outfit"
      var list = names.length <= 1 ? (names[0] || '') : names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1];
      return '✦ Matched to what you asked for' + (colorPhrase ? ' — in ' + colorPhrase : '') + ': ' + list + '.';
    }
    var joined = joinNames(chosen);
    var cat = chosenCategories[0];
    var adjective = cat ? cat.adjective : 'handpicked';
    var occasion = cat ? cat.occasion : 'exactly what you described';
    return '✦ This ' + adjective + ' look pairs ' + joined + ' — perfect for ' + occasion + (colorPhrase ? ', all in ' + colorPhrase : '') + '.';
  }

  function fetchOneCatalogUrl(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('catalog fetch failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        return Array.isArray(data) ? data : [];
      })
      .catch(function (err) {
        console.warn('[AI Stylist] Could not load catalog chunk:', url, err);
        return [];
      });
  }

  function loadCatalog(urlOrUrls) {
    if (CATALOG_CACHE) return Promise.resolve(CATALOG_CACHE);
    if (CATALOG_PROMISE) return CATALOG_PROMISE;

    var urls = [];
    if (typeof urlOrUrls === 'string' && urlOrUrls.trim().charAt(0) === '[') {
      try {
        urls = JSON.parse(urlOrUrls);
      } catch (e) {
        urls = [];
      }
    } else if (typeof urlOrUrls === 'string' && urlOrUrls) {
      urls = [urlOrUrls];
    }

    if (!urls.length) {
      CATALOG_CACHE = [];
      return Promise.resolve(CATALOG_CACHE);
    }

    CATALOG_PROMISE = Promise.all(urls.map(fetchOneCatalogUrl))
      .then(function (parts) {
        var merged = [];
        for (var i = 0; i < parts.length; i++) {
          merged = merged.concat(parts[i]);
        }
        CATALOG_CACHE = merged;
        return merged;
      })
      .catch(function (err) {
        console.warn('[AI Stylist] Could not load product catalog:', err);
        CATALOG_CACHE = [];
        return CATALOG_CACHE;
      });
    return CATALOG_PROMISE;
  }

  function emptyStateHTML(arabicMode) {
    if (arabicMode) {
      return '<p class="ai-stylist-empty" dir="rtl">مفيش نتيجة قريبة من طلبك — جرّب توصفه بطريقة تانية، أو اتفرج على كل المنتجات.</p>' +
        '<a class="ai-stylist-browse-link" href="/collections/all">تصفح كل المنتجات ←</a>';
    }
    return '<p class="ai-stylist-empty">Couldn’t quite find your vibe — try describing it differently, or browse our collections.</p>' +
      '<a class="ai-stylist-browse-link" href="/collections/all">Browse all collections →</a>';
  }

  function runSearch(root, query) {
    var resultsEl = root.querySelector('[data-ai-results]');
    var catalogUrl = root.getAttribute('data-catalog-urls') || root.getAttribute('data-catalog-url');
    if (!query || !query.trim()) return;

    var arabicMode = hasArabic(query);

    resultsEl.innerHTML = arabicMode
      ? '<div class="ai-stylist-loading" dir="rtl">بنجهزلك اللوك…</div>'
      : '<div class="ai-stylist-loading">Styling your look…</div>';
    resultsEl.hidden = false;

    loadCatalog(catalogUrl).then(function (catalog) {
      if (!Array.isArray(catalog) || catalog.length === 0) {
        resultsEl.innerHTML = emptyStateHTML(arabicMode);
        return;
      }

      // Translate Arabic phrases to English engine tokens, then pull out
      // negations ("non hijabi", "بدون حجاب") as hard exclusions before any
      // positive matching can see those words.
      var translated = normalizeAndTranslate(query);
      var negation = extractNegations(translated);
      var queryLower = negation.stripped;
      var maxBudget = parseBudget(queryLower);
      // Colors are detected first and stripped so they never double-count
      // as garment or vibe words.
      var colorResult = detectColors(queryLower);
      var queryColors = colorResult.colors;
      var strippedQuery = colorResult.stripped;
      var audience = detectAudience(strippedQuery);
      var garments = detectGarments(strippedQuery);
      var cats = matchedCategories(strippedQuery);
      var words = tokenize(strippedQuery);
      var adjectives = ADJECTIVES.filter(function (a) { return strippedQuery.indexOf(a) !== -1; });

      var terms = [];
      cats.forEach(function (c) {
        terms = terms.concat(c.matchTerms);
      });
      // de-dupe
      terms = terms.filter(function (t, i) { return terms.indexOf(t) === i; });

      // HARD filters #1 and #2: audience and color. Wrong-gender products
      // and products without a queried color variant are excluded entirely,
      // never merely down-ranked.
      var base = catalog.filter(function (p) {
        return audienceAllows(p, audience) &&
          colorAllows(p, queryColors) &&
          !isExcluded(p, negation.excludeTerms, negation.excludeColors);
      });

      // Per-item budget cap for item-focused queries; outfit queries treat
      // the budget as a total inside the pickers.
      var itemBudgeted = base.filter(function (p) { return maxBudget == null || p.price <= maxBudget; });

      var chosen = null;
      var garmentMode = false;

      if (garments.length > 0) {
        // HARD filter #3: named garment(s)
        var scoredBase = itemBudgeted
          .map(function (p) { return { product: p, score: scoreProduct(p, terms, words, adjectives) }; })
          .sort(function (a, b) { return b.score - a.score; });
        chosen = pickByGarments(scoredBase, garments, garments.length > 1 ? maxBudget : null);
        if (chosen && chosen.length) {
          garmentMode = true;
        } else if ((audience || queryColors.length) && scoredBase.length) {
          // relax the garment filter first: closest relevant items that
          // still satisfy the audience/color hard filters
          chosen = scoredBase
            .filter(function (s) { return s.score > 0; })
            .slice(0, MAX_RESULTS)
            .map(function (s) { return s.product; });
          if (chosen.length) garmentMode = true;
        }
      }

      if (!chosen || chosen.length === 0) {
        // occasion/vibe query (or full relaxation): soft scoring over the
        // audience-filtered catalog
        garmentMode = false;
        var scored = itemBudgeted
          .map(function (p) { return { product: p, score: scoreProduct(p, terms, words, adjectives) }; })
          .filter(function (s) { return s.score > 0; })
          .sort(function (a, b) { return b.score - a.score; });

        if (scored.length === 0) {
          // color-only or audience-only query (e.g. "red products"): the
          // hard filters carry all the intent — show the best-rated matches.
          if (queryColors.length || audience) {
            chosen = itemBudgeted
              .slice()
              .sort(function (a, b) { return (b.rating || 0) - (a.rating || 0); })
              .slice(0, MAX_RESULTS);
            garmentMode = true;
          }
          if (!chosen || chosen.length === 0) {
            resultsEl.innerHTML = emptyStateHTML(arabicMode);
            return;
          }
        } else {
          chosen = pickOutfit(scored, maxBudget);
        }
      }

      if (!chosen || chosen.length === 0) {
        resultsEl.innerHTML = emptyStateHTML(arabicMode);
        return;
      }

      var description = buildDescription(query, cats, chosen, garmentMode, queryColors, arabicMode);
      var cardsHtml = chosen.map(function (p) { return productCardHTML(p, queryColors); }).join('');

      resultsEl.innerHTML =
        '<p class="ai-stylist-sparkle"' + (arabicMode ? ' dir="rtl"' : '') + '>' + escapeHtml(description).replace('✦', '<span class="ai-stylist-sparkle-icon">✦</span>') + '</p>' +
        '<div class="ai-stylist-grid">' + cardsHtml + '</div>';
    });
  }

  function initSection(root) {
    if (root.dataset.aiStylistInit) return;
    root.dataset.aiStylistInit = 'true';

    var input = root.querySelector('[data-ai-input]');
    var button = root.querySelector('[data-ai-submit]');
    var pills = root.querySelectorAll('[data-ai-pill]');

    function submit() {
      runSearch(root, input.value);
    }

    if (button) button.addEventListener('click', submit);
    if (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          submit();
        }
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var text = pill.getAttribute('data-ai-pill');
        if (input) {
          input.value = text;
          input.focus();
        }
        runSearch(root, text);
      });
    });

    root.addEventListener('click', function (e) {
      var heart = e.target.closest('[data-ai-heart]');
      if (heart) {
        e.preventDefault();
        e.stopPropagation();
        heart.classList.toggle('is-active');
      }
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-ai-stylist-section]');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector && e.target.querySelector('[data-ai-stylist-section]');
    if (root) initSection(root);
  });
})();
